import { Component, OnInit, Inject, AfterViewInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { OshWave } from '../../../../interfaces/osh/oshWave';
import { OshProtocol } from '../../../../interfaces/osh/oshProtocol';
import { Utils } from '../../../../utils/utils';

@Component({
    selector: 'oshadmin',
    templateUrl: './oshadmin.component.html',
    styleUrls: ['./oshadmin.component.less', '../../../../style/container-tab-list.component.less', '../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class OshAdminComponent implements OnInit, AfterViewInit, OnDestroy {

    protocols: OshProtocol[] = [];
    selectedWave: OshWave;
    
    private readonly _onDestroy = new Subject<void>();
    
    constructor(
        private readonly http: HttpClient,
        @Inject('BASE_URL') private readonly baseUrl: string,
        public defaults: DefaultValuesService,
        private readonly toastrService: ToastrService,
        private readonly router: Router
    ) {
        this.selectedWave = {
            id: -1,
            name: '',
            changedBy: '',
            isActive: false
        }
    }

    ngOnInit(): void {
        this.loadProtocols();
    }

    ngAfterViewInit() {
        this.defaults?.defaultComponentTab?.(this);
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    loadProtocols() {
        this.http.get(this.baseUrl + 'api/osh/protocols').subscribe({
            next: (result: any) => {
                this.protocols = result || [];
            },
            error: () => {
                this.toastrService.error('Error loading protocols');
            }
        });
    }

    onSelectedWave(wave: OshWave) {
        this.selectedWave = wave;
    }

    onClickDownloadProtocols() {
        Utils.httpDownloadOshProtocolFactors(
            this.http,
            this.baseUrl,
            `OshProtocolFactors`);
    }

    onClickUploadProtocols() {
        this.router.navigate(["file/" + Utils.getFileUploadOshProtocols()]);
    }

    onClickTranslDownload() {
        Utils.httpDownloadOshProtocolFactorsTransl(
            this.http,
            this.baseUrl,
            `OshProtocolFactorsTranslations`);
    }

    onClickTranslUpload() {
        this.router.navigate(["file/" + Utils.getFileUploadOshProtocolsTransl()]);
    }
}

